import checkedFetch from "./checkedFetch";

export default function fetchWithTimestamp(url, init = {}, options = {}) {
  const timestamp = `_=${Date.now()}`;
  const separator = url.includes("?") ? "&" : "?";
  const urlWithTimestamp = `${url}${separator}${timestamp}`;

  return checkedFetch(urlWithTimestamp, init, options);
}
